<template>
  <div>
    <app-header>
      <template #title>
        <h1 class="d-inline me-4">Sign Off</h1>
        <span
          v-bind:class="getStatusColor(signOff.status)"
          class="status"
          >{{ signOff.status }}</span
        >
      </template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'signoffs.overview' }"
      >
        <a class="nav-link">Overview</a>
      </router-link>

      <router-link
        tag="li"
        class="nav-item"
        :to="{
          name: 'signoffs.document-signing',
          params: { sign_request_id: signOff.sign_request.id },
        }"
        v-if="signOff.sign_request"
      >
        <a class="nav-link"><i class="fas fa-signature" /> Document Signing</a>
      </router-link>
    </ul>

    <router-view v-if="loaded" @refresh="loadData"></router-view>
  </div>
</template>

<script>
import { http, queryString, notify } from "utils";
import { mapState, mapActions, mapGetters } from "vuex";
import { unset, cloneDeep } from "lodash";
import Multiselect from "vue-multiselect";
import { helperMethods } from "vx/modules/clients";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  components: {
    Multiselect,
  },
  data: function () {
    return {
      editBudget: null,
      types: ["S1", "S2", "T&M", "CON"],
      statuses: ["Draft", "Sent", "Approved"],
      client: null,
      loaded: false,
      quoteGenerating: false,
    };
  },
  computed: {
    ...mapState("signOff", {
      signOff: "single",
    }),
  },

  mounted: function () {

    var that = this;

    this.$bus.$on("budget-reload-data", function () {
      that.loadData();
    });

    this.loadData();
  },

  methods: {
    ...helperMethods,
    ...mapActions("signOff", {
      getSignOff: "getSingle",
      setSignOffProperty: "setSingleProperty",
    }),
    loadData() {
      this.getSignOff(this.$route.params.signoff_id).then(() => {
        this.editSignOff = cloneDeep(this.signOff);

        Promise.all([this.setClient(this.signOff.client)]).then(() => {
          this.loaded = true;
        })
      })
    },
    getStatusColor(status) {
      switch (status) {
        case "Draft":
          return "status-default";
          break;
        case "Sent":
          return "status-info";
          break;
        case "Pending Approval":
          return "status-warning";
          break;
        case "Approved":
          return "status-info";
          break;
        case "Viewed":
          return "status-primary";
          break;
        case "Declined":
          return "status-warning";
          break;
        case "Signed":
          return "status-success";
          break;
        case "Expired":
          return "status-danger";
          break;
      }
    },
  },
};
</script>
